import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { ClientSessionService } from 'src/core/services/client-session/client-session.service';
import { TenantContextService } from 'src/core/services/tenant-context/tenant-context.service';

export const PORTAL_TENANT_HEADER = 'X-Portal-Tenant';

const SESSION_SCOPE = `${environment.workflowApiUrl}/portal/client`;

// Resolver el tenant es la primera llamada del portal, antes de que exista sesión.
// Los endpoints de aceptación legal SÍ la exigen: su registro es evidencia legal.
const PUBLIC_PATHS = [`${SESSION_SCOPE}/resolve`];

// Ingreso y canje del enlace: corren antes de que exista sesión.
const SESSIONLESS_PATHS = [`${SESSION_SCOPE}/login`, `${SESSION_SCOPE}/access`];

const LOGOUT_PATH = `${SESSION_SCOPE}/logout`;

// Los endpoints con sesión declaran el tenant de la URL en `X-Portal-Tenant`; sin tenant no se envían.
export const clientSessionInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(SESSION_SCOPE)) return next(req);
  if (PUBLIC_PATHS.some((path) => req.url.startsWith(path))) return next(req);

  const sessionless = SESSIONLESS_PATHS.some((path) => req.url.startsWith(path));
  const handle = sessionless ? null : inject(TenantContextService).tenantHash();

  if (!sessionless && !handle && req.url.startsWith(LOGOUT_PATH)) {
    inject(ClientSessionService).clearSession();
    return next(req.clone({ withCredentials: true }));
  }

  if (!sessionless && !handle) {
    inject(Router).navigate(['/invalid-link']);
    return throwError(
      () => new HttpErrorResponse({ status: 401, statusText: 'Unauthorized', url: req.url, error: { code: 'portal_tenant_missing' } })
    );
  }

  return next(
    req.clone({
      withCredentials: true,
      ...(handle ? { setHeaders: { [PORTAL_TENANT_HEADER]: handle } } : {}),
    })
  );
};
